module.exports = __webpack_public_path__ + "static/media/SOLDEMEXICO_25mzo.5dc919f5.jpg";